var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('luma-chat',{ref:"luma",attrs:{"title":"Chat with us","id":"luma","start-minimized":"","websocket-url":_vm.websocketUrl,"rest-url":_vm.restUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }